module.exports = __webpack_public_path__ + "img/bottom-arrow.62372aa.svg";